/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, Typography, Zoom } from "@mui/material";
import React from "react";
import * as PropTypes from "prop-types";

import AppButton from "../../../../../components/AppButton";
import AppAutoComplete from "../../../../../components/AppAutoComplete";
import {
  getFiatCountriesApi,
  getFiatCurrenciesApi,
  logEvent,
} from "../../../../../store/api";
import { useTranslation } from "react-i18next";
import { EVENTS } from "../../../../../utils/events";
import { useSelector } from "react-redux";

export default function CountrySelect({
  setActive,
  active,
  country,
  setCountry,
  currency,
  setCurrency,
}) {
  const { t } = useTranslation();
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);

  const handleChangeCountry = (value) => {
    setCurrency(null);
    setCountry(value);
  }

  const getCurrencies = async () => {
    const resp = await getFiatCurrenciesApi({ country: country.iso2 });
    return resp.result;
  };
  const getCountry = async () => {
    const resp = await getFiatCountriesApi();
    return resp.result.countryList;
  };

  const handleContinue = () => {
    setActive(active + 1)
    logEvent({
      current: EVENTS.BANK_TRANSFER.COUNTRY_CURRENCY_CONTINUE,
      activity: EVENTS.BANK_TRANSFER.COUNTRY_CURRENCY_CONTINUE,
      meta: {
        country,
        currency,
        fiatService
      }
    });
  }

  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 1,
      }}
    >
      <Zoom in={true} style={{ transitionDelay: "100ms" }}>
        <Typography variant="subtitle2" textAlign={"left"}>{t("pockyt.step1.desc")}</Typography>
      </Zoom>
      <Zoom in={true} style={{ transitionDelay: "100ms" }}>
        <Box marginTop={2}>
          <AppAutoComplete
            label={t('Select country')}
            getData={getCountry}
            onSelect={handleChangeCountry}
            defaultValue={country}
            optionKey="name"
          />
        </Box>
      </Zoom>
      {(!!country) && <Zoom in={true} style={{ transitionDelay: "100ms" }}>
        <Box marginTop={2}>
          <AppAutoComplete
            label={t('selectCurrency')}
            getData={getCurrencies}
            onSelect={setCurrency}
            defaultValue={currency}
          />
        </Box>
      </Zoom>}

      {!!(currency && country) && (
        <Zoom in={true} style={{ transitionDelay: "100ms" }}>
          <Box marginTop={2}>
            <AppButton
              title={"Continue"}
              onClick={handleContinue}
              sx={{ marginTop: 2 }}
            />
          </Box>
        </Zoom>
      )}
    </Paper>
  );
}

CountrySelect.propTypes = {
  amount: PropTypes.any,
  setActive: PropTypes.func,
  active: PropTypes.number,
  setShowKytBlocked: PropTypes.func,
  setShowKyt: PropTypes.func,
  country: PropTypes.any,
  setCountry: PropTypes.func,
};
